<template lang="pug">
div(v-if="processo.dadosCadastro && versoes.length > 1")
  .flex
    .row
      .col-first
        .btn-versao
          span.title Versão do cadastro: &nbsp
          el-select.input(
            class="select",
            v-model="versaoSelecionada",
            placeholder="Versões",
            @change="changeVersao"
            no-match-text="Nenhuma versão encontrada",
          )
            el-option(
              v-for="item in versoes",
              :key="item",
              :label="item",
              :value="item"
            )

        el-button.btn-action(
          v-if="showBtnSegundaVia && !isRelatorio"
          tipo="text",
          @click="emitirSegundaVia",
          @emitirSegundaVia="emitirSegundaVia()"
        )
          i.fal.fa-download
          | &nbsp Segunda via do comprovante de envio
        .dados-cadastro
          cadastro-online(
            v-if="getIsOnline()"
            :processoRelatorio="processo"
            :isRelatorio="true"
            :idProcesso="idProcesso"
            :compararRetificacoes="compararRetificacoes"
          )
          cadastro-offline(v-else :processo="processo" :isRelatorio="true" :compararRetificacoes="compararRetificacoes" :versaoCadastro = "versaoSelecionada")
      .col
        .btn-versao
          span.title Versão do cadastro: &nbsp
          el-select.input(
            class="select",
            v-model="versaoSelecionadaComparacao",
            placeholder="Versões",
            @change="changeVersao"
            no-match-text="Nenhuma versão encontrada",
          )
            el-option(
              v-for="item in versoes",
              :key="item",
              :label="item",
              :value="item"
            )

          el-button.btn-action(
            v-if="showBtnSegundaVia && !isRelatorio"
            tipo="text",
            @click="emitirSegundaVia",
            @emitirSegundaVia="emitirSegundaVia()"
          )
            i.fal.fa-download
            | &nbsp Segunda via do comprovante de envio
          .dados-cadastro
            cadastro-online(
              v-if="getIsOnline()"
              :processoRelatorio="processoComparar"
              :isRelatorio="true"
              :idProcesso="idProcesso"
              :compararRetificacoes="compararRetificacoes"
            )
            cadastro-offline(v-if='(compararRetificacoes && processoComparar) && !(getIsOnline())'  :processo="processoComparar" :isRelatorio="true" :compararRetificacoes="compararRetificacoes" :versaoCadastro="versaoSelecionadaComparacao")

div(v-else)
  span.text-empty {{texto}}
</template>
<script>
import { mapActions } from 'vuex'
import '../../../../assets/styles/theme/button.css'
import CadastroOffline from '@/components/InformacoesCadastroOffline'
import CadastroOnline from '@/components/informacoesCadastro/cadastrosOnline/InformacoesCadastroOnline'

export default {
  components: {
    CadastroOffline,
    CadastroOnline
  },
  props: {
    idProcesso: {
      type: Number,
      required: true
    },
    numeroProcesso: {
      type: String,
      required: true
    },
    protocolo: {
      type: String,
      required: true
    },
    showBtnSegundaVia: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      processo: {},
      processoComparar: null,
      versoes: [],
      versaoSelecionada: {},
      versaoSelecionadaComparacao: {},
      compararRetificacoes: null,
      texto: ''
    }
  },

  computed: {
    cadastroOriginal () {
      if (this.getIsOnline()) {
        if (!this.processo) {
          return null
        }

        return { ...this.processo.dadosCadastro, protocolo: this.processo.numeroProtocolo, tipo: this.processo.tipo.codigo }
      }
      return this.processo.dadosCadastro.dados.cadastro
    },
    isRelatorio () {
      return this.$router.currentRoute.name === 'relatorios/home'
    }

  },

  async created () {
    this.versoes = await this.getVersoesByProtocolo(this.protocolo)
    if (this.versoes.length > 1) {
      this.versaoSelecionada = '1.0'
      this.versaoSelecionadaComparacao = this.versoes[0]
      this.getComparar()

      this.processo = await this.getProcesso(
        {
          protocolo: this.protocolo,
          versao: this.versaoSelecionada
        }
      )
      this.processoComparar = await this.getProcesso(
        {
          protocolo: this.protocolo,
          versao: this.versaoSelecionadaComparacao
        }
      )
    } else {
      this.texto = 'Não há mais de uma versão para comparar.'
    }
  },

  methods: {
    ...mapActions({
      getProcesso: 'processos/getProcessoByProtocoloAndVersao',
      getVersoesByProtocolo: 'processos/getVersoesByProtocolo',
      gerarSegundaVia: 'cadastro/emitirSegundaVia',
      getCompararRetificacoes: 'processo/getCompararRetificacoes'
    }),

    getIsOnline () {
      return (this.processo.tipo.codigo === 'PERMUTA' ||
        this.processo.tipo.codigo === 'INFORMACOES' ||
        this.processo.tipo.codigo === 'TRANSFERENCIA_DIREITOS' ||
        this.processo.tipo.codigo === 'AFORAMENTO' ||
        this.processo.tipo.codigo === 'AREAS_PATRIMONIAIS' ||
        this.processo.tipo.codigo === 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
      )
    },

    async changeVersao () {
      this.$store.commit('processos/SET_VERSAO_SELECIONADA', this.versaoSelecionada)
      this.processo = await this.getProcesso(
        {
          protocolo: this.protocolo,
          versao: this.versaoSelecionada
        }
      )
      this.processoComparar = await this.getProcesso(
        {
          protocolo: this.protocolo,
          versao: this.versaoSelecionadaComparacao
        }
      )
      this.getComparar()
    },

    emitirSegundaVia () {
      const params = {
        protocoloCadastro: this.cadastroOriginal.protocolo,
        nomeInteressado: this.cadastroOriginal.interessado.pessoa.pessoaFisica
          ? this.cadastroOriginal.interessado.pessoa.pessoaFisica.nome : this.cadastroOriginal.interessado.pessoa.pessoaJuridica.razaoSocial,
        tipo: this.getTipoProcesso()
      }
      this.gerarSegundaVia(params)
    },

    getTipoProcesso () {
      switch (this.cadastroOriginal.tipo) {
        case 'NAO_ONEROSO':
          return 'Não Oneroso'
        case 'ONEROSO':
          return 'Oneroso'
        case 'PEAS':
          return 'PEAS'
        case 'PEAEX':
          return 'PEAEX'
        case 'TEQ':
          return 'TEQ'
        case 'CERTIDAO_TITULO':
          return 'Certidão de Título'
        case 'AREAS_PATRIMONIAIS':
          return 'Áreas Patrimoniais'
        case 'INFORMACOES':
          return 'Informação'
        case 'PERMUTA':
          return 'Permuta'
        case 'TRANSFERENCIA_DIREITOS':
          return 'Transferência de Direitos'
        case 'AFORAMENTO':
          return 'Aforamento'
        default:
          return this.cadastroOriginal.tipo
      }
    },

    async getComparar () {
      this.compararRetificacoes = await this.getCompararRetificacoes({
        protocolo: this.protocolo,
        versaoSelecionada: this.versaoSelecionada,
        versaoSelecionadaComparacao: this.versaoSelecionadaComparacao
      })
    }
  }
}
</script>

<style scoped>
.modal {
  height: 71vh;
}

.flex {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.margin10 {
  margin-top: 10px;
  color: #303133;
}

.tabContent {
  padding: 2%;
}

.pointer {
  cursor: pointer;
  color: #289f61;
}

.title {
  font-weight: 400;
  color: #909399;
  font-size: 16px;
}

.dados-cadastro {
  padding: 25px 0;
}

.row {
  display: flex;
  flex-direction: row;
}

.col-first {
  display: flex;
  flex-direction: column;
  width: 21%;
  min-width: 480px;
  padding-right: 10px;
}

.col {
  display: flex;
  flex-direction: column;
  width: 21%;
  min-width: 480px;
  max-width: 480px;
  padding-left: 10px;
  border-left: solid 2px;
}

.text-empty {
  display:flex;
  justify-content: center;
  align-content: center;
  justify-self: center;
  color: black !important;
}

@media (max-width: 780px) {
  .row {
    flex-direction: column;
  }
  .col-first {
    min-width: 340px;
  }

  .btn-versao {
    width: 60%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppVisualizarComparadorTab.vue